import { v4 as uuid } from 'uuid';
import { Notification } from '../../models';
import { ICCUser, IEnvironment } from '@communication-center/data-objects';
import { RuntimeFieldMaxLength } from '../../components/EditNotification/EditNotificationContent/SendStepDrawer/NotificationTypePicker/RuntimeField/RuntimeField';
import createDuplicateTitle from '../../helpers/createDuplicateTitle';
import dayjs from 'dayjs';

export const cloneNotificationTemplate = (template: $TSFixMe) => {
    return {
        ...template,
        VisualDesign: {
            ...template.VisualDesign,
            Id: uuid()
        }
    };
};

export const createPublishStates = ({ environments }: { environments: IEnvironment[] }) =>
    environments &&
    environments.map(env => {
        return {
            environmentId: env.id,
            startAt: dayjs().second(0).toDate(),
            endAt: dayjs().second(0).add(30, 'day').toDate()
        };
    });

export const cloneNotification = ({
    notification,
    user,
    environments
}: {
    notification: Notification;
    user: ICCUser;
    environments: IEnvironment[];
}): Notification => {
    return {
        title: notification.title,
        runtimeTitle: notification.runtimeTitle && notification.runtimeTitle.substring(0, RuntimeFieldMaxLength),
        runtimeDescription: notification.runtimeDescription && notification.runtimeDescription.substring(0, RuntimeFieldMaxLength),
        message: notification.message,
        dependencies: notification.dependencies,
        type: notification.type,
        targetAudience: notification.targetAudience,
        user: user,
        systemId: notification.systemId,
        publishStates: createPublishStates({ environments }),
        visualDesignTemplate: notification.visualDesignTemplate,
        visualDesignData: cloneNotificationTemplate(notification.visualDesignData)
    };
};

export const duplicateNotification = ({
    notification,
    notificationsList,
    user,
    environments
}: {
    notification: Notification;
    notificationsList: Notification[];
    user: ICCUser;
    environments: IEnvironment[];
}): Notification => {
    const duplicate = cloneNotification({ notification, user, environments });

    duplicate.title = createDuplicateTitle(notification.title!, notificationsList);

    return duplicate;
};
